import { render } from "./buy-more-options.vue?vue&type=template&id=67f6f83b&scoped=true&ts=true"
import script from "./buy-more-options.vue?vue&type=script&lang=ts"
export * from "./buy-more-options.vue?vue&type=script&lang=ts"

import "./buy-more-options.vue?vue&type=style&index=0&id=67f6f83b&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f6f83b"]])

export default __exports__